import { render, staticRenderFns } from "./offer_2026.vue?vue&type=template&id=1918dde6&scoped=true&"
import script from "./offer_2026.vue?vue&type=script&lang=js&"
export * from "./offer_2026.vue?vue&type=script&lang=js&"
import style0 from "./offer_2026.vue?vue&type=style&index=0&id=1918dde6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1918dde6",
  null
  
)

export default component.exports